import { object, string } from 'yup';
import { addressSchema, buildMetadata, getRequiredMessageDescriptorForField } from '../address/address-fields/address-schema';
import { buildMessageCallback } from '../validation/utilities';
import { FIELD_NAMES } from '../address/address-fields/constants';
import messages from './components/messages';
import { commonMessages } from '../address/address-fields/messages';
import { NZ, AU } from '../constants/country-codes';

// TODO: SPD-11422 - I don't think this schema extension is necessary
// i.e. addressSchema COMPANY is not explicitly required

const { COUNTRY_CODE, EMAIL, COMPANY } = FIELD_NAMES;

const getLocalizedRequiredMessage = (countryCode, fieldSchema) => {
  const fieldSchemaDescription = fieldSchema.describe();
  const requiredCountries = [NZ, AU];
  const fieldName = fieldSchemaDescription.meta.fieldName;
  const messageDescriptor = getRequiredMessageDescriptorForField(countryCode, fieldName);
  if (requiredCountries.includes(countryCode)) {
    return fieldSchema.required(buildMessageCallback(messageDescriptor));
  }
  return fieldSchema.nullable().optional();
};
const shipFromAddressSchema = addressSchema.shape({
  [EMAIL]: string()
    .nullable()
    .email(buildMessageCallback(commonMessages.emailFormatValidationError))
    .meta(buildMetadata(EMAIL))
    .when(COUNTRY_CODE, getLocalizedRequiredMessage),
  [COMPANY]: addressSchema.fields[COMPANY]
    .nullable()
    .required(buildMessageCallback(getRequiredMessageDescriptorForField(COUNTRY_CODE, COMPANY))),
});

const shipFromSchema = object({
  name: string().required(messages.nameRequired),
  originAddress: shipFromAddressSchema,
  returnAddress: shipFromAddressSchema,
});

export default shipFromSchema;
